import type { FaireProductEntity } from "../../entity_types/product";

export const p_p6ryxeb6js: FaireProductEntity = {
  token: "p_p6ryxeb6js",
  type: "product",
  name: "Kind to Scalp | Organic Therapeutic Scalp Oil",
  brandToken: "b_97fwzxfjvs",
  brandName: "Simply Happy",
  imageUrl:
    "https://cdn.faire.com/fastly/309fdc4336590149815bc6e6220d2afd86b85ade38bee9d62997cc7c18085bd2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e4126cbee28fd4d7f6e1f76d0abd2f94e173dbc5b8688a731de388221f92679e.jpeg",
    "https://cdn.faire.com/fastly/0903cea853cd834caf4bfd58e19b151a91ba00e5b90d84c9c69c73747823fced.jpeg",
    "https://cdn.faire.com/fastly/7fd5a061eaca0c1481978556f106ddf7cc8c7dc314ba06691bc69b40f265489f.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "A lightweight, deeply nourishing scalp oil made with organic, plant-based ingredients to soothe dryness, balance oil production, and support healthy hair growth. Ideal for sensitive, dry, or irritated scalps.\n\nKey Benefits:\n✔️ Hydrates & balances scalp\n✔️ Calms irritation & dryness\n✔️ Supports strong, healthy hair\n✔️ Invigorates with cooling essential oils\n\nOrganic Ingredients: \n-Jojoba, Castor, Almond, & Vitamin E Oils: Moisturize and nourish.\n-Peppermint, Spearmint, Tea Tree, Rosemary, Clary Sage & Cedarwood: Refresh, clarify, and stimulate scalp health.\n\nUse as a lightweight leave-in or a deep pre-wash treatment.\nSmall-batch made in Minnesota. 1 oz glass bottle.",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:30.083Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
